import { Navigate } from 'react-router-dom';
/**
 *
 * Settings Routes
 *
 * Please note: routes need to be added in main routes file at src/modules/routes.js
 * or src/{mobileApp/webApp}/routes.js depending on current file location
 */
import { SettingsSubMenuRoutes } from 'modules/Settings/settingsPagesConfig';
import { lazyLoad } from 'utils/loadable';

const SettingsPage = lazyLoad(() =>
  import(/*  webpackChunkName: 'settingsPage', webpackPrefetch: true */ '.'),
);

// const SettingsViewPage = lazyLoad(() =>
//   import(
//     /*  webpackChunkName: 'SettingsView', webpackPrefetch: true */ './components/SettingsView'
//   ),
// );

const TeamInvitationsPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'teamInvitationsPage', webpackPrefetch: true */ './components/Team/TeamInvitations'
  ),
);

const AdminUsersTablePage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'AdminUsersTablePage', webpackPrefetch: true */ './components/AdminUsers/AdminUsersTable'
  ),
);

const AttendanceManagementTablePage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'AttendanceManagementTablePage', webpackPrefetch: true */ './components/AttendanceManagement/AttendanceManagementTable'
  ),
);

const TeamTablePage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'TeamTablePage', webpackPrefetch: true */ './components/Team/TeamTable'
  ),
);

const CitizenInvitationsPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'citizenInvitationsPage', webpackPrefetch: true */ './components/Citizens/CitizenInvitations'
  ),
);

const CitizensTablePage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'CitizensTablePage', webpackPrefetch: true */ './components/Citizens/CitizensTable'
  ),
);

const SupportComplaintCategorySettingsPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'SupportComplaintCategorySettingsPage', webpackPrefetch: true */ './components/Support/SupportComplaintCategorySettings'
  ),
);

const SupportStatusSettingsPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'SupportStatusSettingsPage', webpackPrefetch: true */ './components/Support/SupportStatusSettings'
  ),
);

const SupportCallbackStatusSettingsPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'SupportCallbackStatusSettingsPage', webpackPrefetch: true */ './components/Support/SupportCallbackStatusSettings'
  ),
);

const SupportAgentsAvailabilityStatus = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'SupportAgentsAvailabilityStatus', webpackPrefetch: true */ './components/Support/SupportAgentsAvailabilityStatus'
  ),
);

const SupportBusinessEnquirySettingsPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'SupportBusinessEnquirySettings', webpackPrefetch: true */ './components/Support/SupportBusinessEnquirySettings'
  ),
);

const SupportBusinessEnquirySourcesPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'SupportBusinessEnquirySources', webpackPrefetch: true */ './components/Support/SupportBusinessEnquirySources'
  ),
);

const SupportPrioritySettingsPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'SupportPrioritySettingsPage', webpackPrefetch: true */ './components/Support/SupportPrioritySettings'
  ),
);

const SupportSkillsSettingsPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'SupportSkillsSettingsPage', webpackPrefetch: true */ './components/Support/SupportSkillsSettings'
  ),
);

const SupportTiersSettingsPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'SupportTiersSettingsPage', webpackPrefetch: true */ './components/Support/SupportTiersSettings'
  ),
);

const SupportAgentsSettingsPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'SupportAgentsSettingsPage', webpackPrefetch: true */ './components/Support/SupportAgentsSettings'
  ),
);

const SocialSettingsPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'SocialSettingsPage', webpackPrefetch: true */ './components/SocialSettings'
  ),
);

const SLASettingsPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'SLASettingsPage', webpackPrefetch: true */ './components/Integration/SLASettings'
  ),
);

const SupportLanguageSettingPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'SupportLanguageSettingPage', webpackPrefetch: true */ './components/Support/SupportLanguageSettings'
  ),
);

// const SupportAssistantSettingPage = lazyLoad(() =>
//   import(
//     /*  webpackChunkName: 'SupportAssistantSettingPage', webpackPrefetch: true */ './components/Support/SupportAssistantSettings'
//   ),
// );

const AccountSettingsPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'AccountSettingsPage', webpackPrefetch: true */ './components/AccountSettings'
  ),
);

const PreferencesSettingsPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'PreferencesSettingsPage', webpackPrefetch: true */ './components/AccountPreferenceSettings/index'
  ),
);

const LinkedAccountsPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'LinkedAccountsPage', webpackPrefetch: true */ './components/Account/LinkedAccounts'
  ),
);

const PaymentSettingsPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'PaymentSettingsPage', webpackPrefetch: true */ './components/PaymentSettings'
  ),
);

// const PartnerAccountPage = lazyLoad(() =>
//   import(
//     /*  webpackChunkName: 'PartnerAccountPage', webpackPrefetch: true */ './components/Account/PartnerAccounts'
//   ),
// );

const SupportDepartmentsSettingsPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'SupportDepartmentsSettingsPage', webpackPrefetch: true */ './components/Support/SupportDepartmentSettings'
  ),
);

const SupportDesignationSettingsPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'SupportDesignationSettingsPage', webpackPrefetch: true */ './components/Support/SupportDesignationSettings'
  ),
);

const AccountAppearancePage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'AccountAppearancePage', webpackPrefetch: true */ './components/Account/Appearences'
  ),
);

// const KnowledgeBasePage = lazyLoad(() =>
//   import(
//     /*  webpackChunkName: 'KnowledgeBase', webpackPrefetch: true */ './components/KnowledgeBase'
//   ),
// );

// const TrainAiPage = lazyLoad(() =>
//   import(
//     /*  webpackChunkName: 'TrainAi', webpackPrefetch: true */ './components/TrainAi'
//   ),
// );

const CredentialsPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'Credentials', webpackPrefetch: true */ './components/Credentials'
  ),
);

const BillingInvoicePage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'BillingInvoice', webpackPrefetch: true */ './components/Billing/BillingInvoice'
  ),
);

const BillingReceiptPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'BillingReceipt', webpackPrefetch: true */ './components/Billing/BillingReceipt'
  ),
);

const BillingSubcriptionPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'BillingSubcription', webpackPrefetch: true */ './components/Billing/BillingSubcription'
  ),
);

const SessionManagementPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'SessionManagementPage', webpackPrefetch: true */ './components/Billing/SessionManagement'
  ),
);

const BillingAndPaymentsPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'BillingAndPaymentsPage', webpackPrefetch: true */ './components/Billing/BillingAndPayments'
  ),
);

const SubscriptionRedirectPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'SubscriptionRedirectPage', webpackPrefetch: true */ './components/Billing/SubscriptionRedirectPage'
  ),
);

const RazorpaySuccessPagePage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'RazorpaySuccessPage', webpackPrefetch: true */ './components/Billing/RazorpaySuccessPage'
  ),
);

const BillingPaymentDetailsPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'BillingPaymentDetails', webpackPrefetch: true */ './components/Billing/BillingPaymentDetails'
  ),
);

// const SettingsIntegratedAppsPage = lazyLoad(() =>
//   import(
//     /*  webpackChunkName: 'SettingsIntegratedApps', webpackPrefetch: true */ './components/IntegratedApps/Index'
//   ),
// );

const ShareLinkSettingsPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'ShareLinkSettings', webpackPrefetch: true */ './components/ShareLinkSettings'
  ),
);

const AiAssistantFunctionPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'AiAssistantFunctionPage', webpackPrefetch: true */ './components/AiAssistant/AiAssistantFunctions'
  ),
);
const AiAssistantMenuPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'AiAssistantMenuPage', webpackPrefetch: true */ './components/AiAssistant/AiAssistantMenu'
  ),
);
const AiAssistantThemePage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'AiAssistantThemePage', webpackPrefetch: true */ './components/AiAssistant/AiAssistantTheme'
  ),
);

const SetupPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'Setup', webpackPrefetch: true */ './components/Setup'
  ),
);

const PaymentMethodSettingPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'PaymentMethodSettingPage', webpackPrefetch: true */ './components/Ecommerce/PaymentsMethodSetting/PaymentsMethodSetting'
  ),
);

const CreditTermsPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'CreditTermsPage', webpackPrefetch: true */ './components/Ecommerce/CreditTerm/CreditTerm'
  ),
);

const OrderStatusPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'OrderStatusPage', webpackPrefetch: true */ './components/Ecommerce/OrderStatus/OrderStatus'
  ),
);

const UnitsPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'UnitsPage', webpackPrefetch: true */ './components/ProductsSettings/components/Units'
  ),
);

const TaxPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'TaxPage', webpackPrefetch: true */ './components/ProductsSettings/components/Tax'
  ),
);

const CategoriesPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'CategoriesPage', webpackPrefetch: true */ './components/ProductsSettings/components/Categories'
  ),
);

const BrandsPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'BrandsPage', webpackPrefetch: true */ './components/ProductsSettings/components/Brands'
  ),
);

const ProductsPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'ProductsPage', webpackPrefetch: true */ './components/ProductsSettings/components/Products'
  ),
);

const CateLogsPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'CateLogsPage', webpackPrefetch: true */ './components/ProductsSettings/components/Catelogs'
  ),
);

const BranchesPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'BranchesPage', webpackPrefetch: true */ './components/Branches'
  ),
);

const BusinessUnitsPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'BusinessUnitsPage', webpackPrefetch: true */ './components/BusinessUnits'
  ),
);

const QrBatchListPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'QrBatchListPage', webpackPrefetch: true */ './components/QRManagement/GenerateQR/components/QrListView/QrBatchListView'
  ),
);

const QrCodesListingTabs = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'QrCodesListingTabs', webpackPrefetch: true */ './components/QRManagement/GenerateQR/QrCodesListingTabs'
  ),
);

const QrHistoryPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'QrHistoryPage', webpackPrefetch: true */ './components/QRManagement/QRHistory/QRHistory'
  ),
);

const JobsSettingsPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'JobsSettingsPage', webpackPrefetch: true */ './components/JobsSettings/JobsSettings'
  ),
);

const JobsApplicationsSettingsPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'JobsApplicationsSettingsPage', webpackPrefetch: true */ './components/JobsSettings/JobsApplicationsSettings'
  ),
);

const JobsInterviewSettingsPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'JobsInterviewSettingsPage', webpackPrefetch: true */ './components/JobsSettings/JobsInterviewSettings'
  ),
);

const LoyaltyCategoriesPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'LoyaltyCategoriesPage', webpackPrefetch: true */ './components/Loyalty/LoyaltyCategories'
  ),
);

const LoyaltyUsageListingTabs = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'LoyaltyUsageListingTabs', webpackPrefetch: true */ './components/Loyalty/Components/LoyaltyUsageListingTabs'
  ),
);

const LoyaltyTaxHistoryPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'LoyaltyTaxHistoryPage', webpackPrefetch: true */ './components/Loyalty/LoyaltyTaxHistory'
  ),
);

const LoyaltyAdjustmemtsPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'LoyaltyAdjustmemtsPage', webpackPrefetch: true */ './components/Loyalty/LoyaltyAdjustments'
  ),
);

const LoyaltyOverviewPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'LoyaltyOverviewPage', webpackPrefetch: true */ './components/Loyalty/LoyaltyOverview'
  ),
);

const LoyaltyProgramListingTab = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'LoyaltyProgramListingTab', webpackPrefetch: true */ './components/Loyalty/Components/LoyaltyProgramListingTab'
  ),
);

const LoyaltyDefaultFieldValuesPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'LoyaltyDefaultFieldValuesPage', webpackPrefetch: true */ './components/Loyalty/LoyaltyDefaultFieldValues'
  ),
);

const LifecyclePage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'LifecyclePage', webpackPrefetch: true */ './components/LifeCycle/index'
  ),
);

const CustomerRelationshipTypePage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'CustomerRelationshipTypePage', webpackPrefetch: true */ './components/LifeCycle/CustomerRelationshipType'
  ),
);

const PartnerRelationshipTypePage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'PartnerRelationshipTypePage', webpackPrefetch: true */ './components/PRM/PartnerRelationshipType'
  ),
);

const PartnerLeadLifecyclePage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'PartnerLeadLifecyclePage', webpackPrefetch: true */ './components/PRM/PartnerLeadLifecycle'
  ),
);

const GeoManagementPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'GeoManagementPage', webpackPrefetch: true */ './components/GeoManagement'
  ),
);

const PRMPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'PRMPage', webpackPrefetch: true */ './components/PRM'
  ),
);

const IntegratedAppsPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'PRMPage', webpackPrefetch: true */ '../IntegratedApps/index'
  ),
);

const welcomeKitPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'welcomeKitPage', webpackPrefetch: true */ './components/WelcomeKit/index'
  ),
);

const FieldSalsesOfficersPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'FieldSalsesOfficersPage', webpackPrefetch: true */ './components/FieldAssist/FieldSalesOfficers'
  ),
);

const FieldSupportOfficersPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'FieldSupportOfficersPage', webpackPrefetch: true */ './components/FieldAssist/FieldSupportOfficers'
  ),
);

const BannerTablePage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'welcomeKitPage', webpackPrefetch: true */ './components/Banner/index'
  ),
);

const PartnerClientInvitationPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'PartnerClientInvitationPage', webpackPrefetch: true */ './components/PRM/components/PartnerClientInvitations'
  ),
);

const CustomerClientInvitationPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'CustomerClientInvitationPage', webpackPrefetch: true */ './components/CRM/components/CustomerClientInvitation'
  ),
);

const RedemptionCatalogPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'RedemptionCatalogPage', webpackPrefetch: true */ './components/RedemptionAssist/RedemptionCatelog'
  ),
);

const RedemptionCategoryPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'RedemptionCategoryPage', webpackPrefetch: true */ './components/RedemptionAssist/RedemptionCategory'
  ),
);

const RedemptionItemsListingTabPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'RedemptionItemsListingTabPage', webpackPrefetch: true */ './components/RedemptionAssist/Components/RedemptionItemsListingTab'
  ),
);

const RewardUsagePage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'RewardUsagePage', webpackPrefetch: true */ './components/RedemptionAssist/RewardUsage'
  ),
);

const RewardRejectReasonsPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'RewardRejectReasonsPage', webpackPrefetch: true */ './components/RedemptionAssist/RewardRejectReasons'
  ),
);

const ProductScanUsageTabs = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'ProductScanUsageTabs', webpackPrefetch: true */ './components/Loyalty/Components/ProductScanUsageTabs'
  ),
);

const BeneficiaryTablePage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'BeneficiaryTablePage', webpackPrefetch: true */ './components/Loyalty/Components/BeneficiaryTable'
  ),
);

const TargetTypesPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'TargetTypesPage', webpackPrefetch: true */ './components/Target/TargetTypes'
  ),
);
const TargetRewardTypesPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'TargetRewardTypesPage', webpackPrefetch: true */ './components/Target/TargetRewardTypes'
  ),
);
const RewardConfigPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'RewardConfigPage', webpackPrefetch: true */ './components/Target/TargetRewardConfig'
  ),
);
const TargetProgramPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'TargetProgramPage', webpackPrefetch: true */ './components/Target/TargetProgram'
  ),
);
const TargetAssignmentPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'TargetAssignmentPage', webpackPrefetch: true */ './components/Target/TargetAssignment'
  ),
);

const RoleSettingsListingTabsPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'RoleSettingsListingTabsPage', webpackPrefetch: true */ './components/AppManagement/RoleSettingsListingTabs'
  ),
);

export const settingsMenuRoutes = allowAdminRoutes => [
  ...(allowAdminRoutes
    ? [
        {
          component: TeamInvitationsPage,
          title: 'Team Invitations',
          path: SettingsSubMenuRoutes.TEAM_INVITATIONS,
        },
        {
          component: TeamTablePage,
          title: 'Teams',
          path: SettingsSubMenuRoutes.TEAM_LIST,
        },
        {
          component: AdminUsersTablePage,
          title: 'Admin Users',
          path: SettingsSubMenuRoutes.ADMIN_USERS,
        },
        {
          component: AttendanceManagementTablePage,
          title: 'Attendance',
          path: SettingsSubMenuRoutes.ATTENDANCE_MANAGEMENT,
        },
        {
          component: CitizenInvitationsPage,
          title: 'Citizen Invitations',
          path: SettingsSubMenuRoutes.CUSTOMERS_INVITATIONS,
        },
        {
          component: CitizensTablePage,
          title: 'Citizen List',
          path: SettingsSubMenuRoutes.CUSTOMERS_LIST,
        },
        {
          component: SupportComplaintCategorySettingsPage,
          title: 'Issue Categories',
          path: SettingsSubMenuRoutes.SUPPORT_COMPLAINT_CATEGORIES,
        },
        {
          component: SupportStatusSettingsPage,
          title: 'Ticket Status',
          path: SettingsSubMenuRoutes.SUPPORT_STATUS,
        },
        {
          component: SupportCallbackStatusSettingsPage,
          title: 'Callback Status',
          path: SettingsSubMenuRoutes.SUPPORT_CALLBACK_STATUS,
        },
        {
          component: SupportAgentsAvailabilityStatus,
          title: 'Availability Status',
          path: SettingsSubMenuRoutes.AGENT_AVAILABILITY_STATUS,
        },
        {
          component: SupportBusinessEnquirySourcesPage,
          title: 'Lead Sources',
          path: SettingsSubMenuRoutes.LEAD_SOURCES,
        },
        {
          component: SupportBusinessEnquirySettingsPage,
          title: 'Lead Management Status',
          path: SettingsSubMenuRoutes.LEAD_MANAGEMENT_STATUS,
        },
        {
          component: SupportPrioritySettingsPage,
          title: 'Priority Settings',
          path: SettingsSubMenuRoutes.SUPPORT_PRIORITY,
        },
        {
          component: SupportSkillsSettingsPage,
          title: 'Manage Skills',
          path: SettingsSubMenuRoutes.SUPPORT_SKILL,
        },
        {
          component: SupportTiersSettingsPage,
          title: 'Manage Tiers',
          path: SettingsSubMenuRoutes.SUPPORT_TIER,
        },
        {
          component: SupportAgentsSettingsPage,
          title: 'Agent Settings',
          path: SettingsSubMenuRoutes.SUPPORT_AGENTS,
        },
        {
          component: SocialSettingsPage,
          title: 'Social Settings',
          path: SettingsSubMenuRoutes.INTEGRATION_SOCIAL_SETTINGS,
        },
        {
          component: SLASettingsPage,
          title: 'SLA Settings',
          path: SettingsSubMenuRoutes.SUPPORT_SLA_SETTINGS,
        },
        {
          component: SupportLanguageSettingPage,
          title: 'Language Settings',
          path: SettingsSubMenuRoutes.SUPPORT_LANGUAGE_SETTINGS,
        },
        // {
        //   component: SupportAssistantSettingPage,
        //   title: 'Assistant Settings',
        //   path: SettingsSubMenuRoutes.SUPPORT_ASSISTANT_SETTINGS,
        // },
        {
          component: LinkedAccountsPage,
          title: 'Organisation',
          path: SettingsSubMenuRoutes.LINKED_ACCOUNTS,
        },
        // {
        //   component: PartnerAccountPage,
        //   title: 'Partner Account Settings',
        //   path: SettingsSubMenuRoutes.PARTNER_ACCOUNTS,
        // },
        {
          component: SupportDepartmentsSettingsPage,
          title: 'Departments',
          path: SettingsSubMenuRoutes.ACCOUNT_DEPTS,
        },
        {
          component: SupportDesignationSettingsPage,
          title: 'Designations',
          path: SettingsSubMenuRoutes.TEAM_DESIGNATIONS,
        },
        {
          component: PaymentSettingsPage,
          title: 'Payment Settings',
          path: SettingsSubMenuRoutes.PAYMENT_SETTINGS,
        },
        {
          component: AccountAppearancePage,
          title: 'Appearance',
          path: SettingsSubMenuRoutes.ACCOUNT_APPEARANCE,
        },
        // {
        //   component: KnowledgeBasePage,
        //   // title: 'Fine Tuning',
        //   path: SettingsSubMenuRoutes.FINE_TUNING,
        // },
        // {
        //   component: TrainAiPage,
        //   title: 'AI Training',
        //   path: SettingsSubMenuRoutes.TRAIN_AI,
        // },
        {
          component: CredentialsPage,
          title: 'Credentials',
          path: SettingsSubMenuRoutes.APP_CREDENTIAL,
        },
        {
          component: BillingInvoicePage,
          title: 'Invoices',
          path: SettingsSubMenuRoutes.BILLING_INVOICES,
        },
        {
          component: BillingReceiptPage,
          title: 'Receipts',
          path: SettingsSubMenuRoutes.BILLING_RECEIPTS,
        },
        {
          component: BillingSubcriptionPage,
          title: 'Subscription',
          path: SettingsSubMenuRoutes.BILLING_SUBSCRIPTION,
        },
        {
          component: BillingAndPaymentsPage,
          title: 'Billing and Payment',
          path: SettingsSubMenuRoutes.BILLING_AND_PAYMENT,
        },
        {
          component: SessionManagementPage,
          title: 'Session Logs',
          path: SettingsSubMenuRoutes.SESSION_MANAGEMENT,
        },
        {
          component: SubscriptionRedirectPage,
          title: 'Redirect page',
          path: '/billing/SubscriptionRedirectPage',
        },
        {
          component: RazorpaySuccessPagePage,
          title: 'Payment Successful',
          path: '/billing/payment-successful',
        },
        {
          component: BillingPaymentDetailsPage,
          title: 'Payments',
          path: SettingsSubMenuRoutes.BILLING_PAYMENT_DETAILS,
        },
        // {
        //   component: SettingsIntegratedAppsPage,
        //   title: 'Integrated Apps',
        //   path: SettingsSubMenuRoutes.INTEGRATED_APPS,
        // },
        // {
        //   component: RoleSettingsPage,
        //   title: 'Role Settings',
        //   path: SettingsSubMenuRoutes.ROLE_SETTINGS,
        // },
        {
          component: AiAssistantFunctionPage,
          title: 'Functions',
          path: SettingsSubMenuRoutes.AI_ASSISTANT_FUNCTIONS,
        },
        {
          component: AiAssistantMenuPage,
          title: 'Menus',
          path: SettingsSubMenuRoutes.AI_ASSISTANT_MENU,
        },
        {
          component: AiAssistantThemePage,
          title: 'Theme',
          path: SettingsSubMenuRoutes.AI_ASSISTANT_THEME,
        },
        {
          component: SetupPage,
          title: 'Setup',
          path: SettingsSubMenuRoutes.SETUP_SETTINGS,
        },
        {
          component: PaymentMethodSettingPage,
          title: 'Payment Method',
          path: SettingsSubMenuRoutes.PAYMENT_METHOD_SETTINGS,
        },
        {
          component: CreditTermsPage,
          title: 'Credit Terms',
          path: SettingsSubMenuRoutes.CREDIT_TERMS,
        },
        {
          component: OrderStatusPage,
          title: 'Order Status',
          path: SettingsSubMenuRoutes.ORDER_STATUS,
        },
        {
          component: UnitsPage,
          title: 'Units',
          path: SettingsSubMenuRoutes.UNITS,
        },
        {
          component: TaxPage,
          title: 'Tax',
          path: SettingsSubMenuRoutes.TAX,
        },
        {
          component: CategoriesPage,
          title: 'Categories',
          path: SettingsSubMenuRoutes.CATEGORIES,
        },
        {
          component: BrandsPage,
          title: 'Brands',
          path: SettingsSubMenuRoutes.BRANDS,
        },
        {
          component: ProductsPage,
          title: 'Products',
          path: SettingsSubMenuRoutes.PRODUCTS,
        },
        {
          component: CateLogsPage,
          title: 'Catelogs',
          path: SettingsSubMenuRoutes.CATALOGS,
        },
        {
          component: QrBatchListPage,
          title: 'QR Batch List',
          path: SettingsSubMenuRoutes.QR_BATCH_LIST,
        },
        {
          component: QrCodesListingTabs,
          title: 'QR Batch Code List',
          path: SettingsSubMenuRoutes.QR_BATCH_CODE_LIST,
        },
        {
          component: QrHistoryPage,
          title: 'QR History',
          path: SettingsSubMenuRoutes.QR_HISTORY,
        },
        {
          component: JobsSettingsPage,
          title: 'Job List',
          path: SettingsSubMenuRoutes.JOBS_SETTINGS,
        },
        {
          component: JobsApplicationsSettingsPage,
          title: 'Job Applications',
          path: SettingsSubMenuRoutes.JOBS_APPLICATIONS_SETTINGS,
        },
        {
          component: JobsInterviewSettingsPage,
          title: 'Job Interview',
          path: SettingsSubMenuRoutes.JOBS_INTERVIEW_SETTINGS,
        },
        {
          component: LoyaltyCategoriesPage,
          title: 'Loyalty Tiers',
          path: SettingsSubMenuRoutes.LOYALTY_TIERS,
        },
        {
          component: LoyaltyUsageListingTabs,
          title: 'Loyalty History',
          path: SettingsSubMenuRoutes.LOYALTY_HISTORY,
        },
        {
          component: LoyaltyTaxHistoryPage,
          title: 'Tax History',
          path: SettingsSubMenuRoutes.TAX_HISTORY,
        },
        {
          component: LoyaltyAdjustmemtsPage,
          title: 'Adjust Reasons',
          path: SettingsSubMenuRoutes.LOYALTY_ADJUSTMENTS,
        },
        {
          component: LoyaltyOverviewPage,
          title: 'Loyalty Overview',
          path: SettingsSubMenuRoutes.LOYALTY_OVERVIEW,
        },
        {
          component: LoyaltyProgramListingTab,
          title: 'Loyalty Programs',
          path: SettingsSubMenuRoutes.LOYALTY_PROGRAM,
        },
        {
          component: LoyaltyDefaultFieldValuesPage,
          title: 'Loyalty Default Settings',
          path: SettingsSubMenuRoutes.LOYALTY_DEFAULT_FIELD_VALUES,
        },
        {
          component: BranchesPage,
          title: 'Branches',
          path: SettingsSubMenuRoutes.ACCOUNT_BRANCHES,
        },
        {
          component: BusinessUnitsPage,
          title: 'Business Units',
          path: SettingsSubMenuRoutes.BUSINESS_UNIT,
        },
        {
          component: LifecyclePage,
          title: 'Lead Lifecycle',
          path: SettingsSubMenuRoutes.CUSTOMER_LIFE_CYCLE,
        },
        {
          component: CustomerRelationshipTypePage,
          title: 'Relationship Type',
          path: SettingsSubMenuRoutes.CUSTOMER_RELATIONSHIP_TYPE,
        },
        {
          component: PartnerRelationshipTypePage,
          title: 'Relationship Type',
          path: SettingsSubMenuRoutes.PARTNER_RELATIONSHIP_TYPE,
        },
        {
          component: PartnerLeadLifecyclePage,
          title: 'Lead Lifecycle',
          path: SettingsSubMenuRoutes.PARTNER_LIFE_CYCLE,
        },
        {
          component: GeoManagementPage,
          title: 'Geo Management',
          path: SettingsSubMenuRoutes.GEO_MANAGEMENT,
        },
        {
          component: PRMPage,
          title: 'PRM(DMS)',
          path: SettingsSubMenuRoutes.PRM,
        },
        {
          component: IntegratedAppsPage,
          title: 'Integrated Apps',
          path: SettingsSubMenuRoutes.INTEGRATED_APPS,
        },
        {
          component: welcomeKitPage,
          title: 'Welcome Kit',
          path: SettingsSubMenuRoutes.WELCOME_KIT,
        },
        {
          component: FieldSalsesOfficersPage,
          title: 'Field Sales Officers',
          path: SettingsSubMenuRoutes.FIELD_SALES_OFFICERS,
        },
        {
          component: FieldSupportOfficersPage,
          title: 'Field Support Officers',
          path: SettingsSubMenuRoutes.FIELD_SUPPORT_OFFICERS,
        },
        {
          component: BannerTablePage,
          title: 'Banners',
          path: SettingsSubMenuRoutes.BANNERS,
        },
        {
          component: PartnerClientInvitationPage,
          title: 'Partner Client Invitations',
          path: SettingsSubMenuRoutes.PARTNER_CLIENT_INVITE,
        },
        {
          component: CustomerClientInvitationPage,
          title: 'Customer Client Invitations',
          path: SettingsSubMenuRoutes.CUSTOMER_CLIENT_INVITE,
        },
        {
          component: RedemptionCatalogPage,
          title: 'Redemption Catalog',
          path: SettingsSubMenuRoutes.REDEMPTION_CATALOG,
        },
        {
          component: RedemptionCategoryPage,
          title: 'Redemption Category',
          path: SettingsSubMenuRoutes.REDEMPTION_CATEGORY,
        },
        {
          component: RedemptionItemsListingTabPage,
          title: 'Redemption Items',
          path: SettingsSubMenuRoutes.REDEMPTION_ITEMS,
        },
        {
          component: RewardUsagePage,
          title: 'Reward History',
          path: SettingsSubMenuRoutes.REDEMPTION_REWARD_HISTORY,
        },
        {
          component: RewardRejectReasonsPage,
          title: 'Reject Reasons',
          path: SettingsSubMenuRoutes.REDEMPTION_REWARD_REJECT_REASONS,
        },
        {
          component: ProductScanUsageTabs,
          title: 'Product History',
          path: SettingsSubMenuRoutes.PRODUCT_HISTORY,
        },
        {
          component: BeneficiaryTablePage,
          title: 'Supplier Logs',
          path: SettingsSubMenuRoutes.SUPPLIER_LOGS,
        },
        {
          component: TargetTypesPage,
          title: 'Target Types',
          path: SettingsSubMenuRoutes.TARGET_TYPES,
        },
        {
          component: TargetRewardTypesPage,
          title: 'Target Reward Types',
          path: SettingsSubMenuRoutes.TARGET_REWARD_TYPES,
        },
        {
          component: RewardConfigPage,
          title: 'Reward Config',
          path: SettingsSubMenuRoutes.REWARD_CONFIG,
        },
        {
          component: TargetProgramPage,
          title: 'Target Program',
          path: SettingsSubMenuRoutes.TARGET_PROGRAM,
        },
        {
          component: TargetAssignmentPage,
          title: 'Target Assignment',
          path: SettingsSubMenuRoutes.TARGET_ASSIGNMENT,
        },
        {
          component: RoleSettingsListingTabsPage,
          title: 'Role Settings',
          path: SettingsSubMenuRoutes.ROLE_SETTINGS,
        },
      ]
    : []),
  {
    component: AccountSettingsPage,
    title: 'Account Settings',
    path: SettingsSubMenuRoutes.ACCOUNT_SETTINGS,
  },
  {
    component: PreferencesSettingsPage,
    title: 'Preference Settings',
    path: SettingsSubMenuRoutes.PREFERENCE_SETTINGS,
  },
  {
    component: ShareLinkSettingsPage,
    title: 'Share Link Settings',
    path: SettingsSubMenuRoutes.SHARE_LINK_SETTINGS,
  },
  // {
  //   component: SettingsViewPage,
  //   title: 'Settings',
  //   path: SettingsSubMenuRoutes.SETTINGS_VIEW,
  // },
];

// routes declaration
export const settingsRoutes = [
  {
    component: Navigate,
    path: '/settings',

    replace: true,
    to: '/settings' + SettingsSubMenuRoutes.DEFAULT,
    toAdmin: '/settings' + SettingsSubMenuRoutes.DEFAULT_ADMIN,
    needsAuth: true,
  },
  {
    component: SettingsPage,
    title: 'Settings',
    path: '/settings/*',
    needsAuth: true,
  },
];
